module.exports = __webpack_public_path__ + "static/media/4.3 Palamedesz Detail Spieler_klein.22d7a5eb.jpg";